import { Component, OnInit } from '@angular/core';
import { Page } from '../../Model/pageRoles';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';
import { PageRolesService } from '../../Service/page-roles.service';
@Component({
  selector: 'page-roles-details',
  templateUrl: './page-roles-details.component.html',
  styleUrls: ['./page-roles-details.component.scss']
})
export class PageRolesDetailsComponent implements OnInit {

model = {} as Page;
  constructor(
    private sanitizer: DomSanitizer,
    private service: PageRolesService,
    private diag: NbDialogRef<PageRolesDetailsComponent>,
    private route : Router
  ) {}

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     }); 

     for (const key in this.model.children) {
  if (this.model.children.hasOwnProperty(key)) {
    console.log(`Key: ${key}, Value: ${this.model.children[key]}`);
  }
}

     for (const key in this.model.roles) {
  if (this.model.roles.hasOwnProperty(key)) {
    console.log(`Key: ${key}, Value: ${this.model.roles[key]}`);
  }
}
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }

  close() {
    this.diag.close();
  }
}
